module.exports = __webpack_public_path__ + "img/app_btn1.df5bea59.png";